import { VCS_INTEGRATION_DETAILS_UNION } from "constants/vcsProviders";
import { GitHubAppStatus, VcsIntegration, VcsProvider } from "types/generated";

export enum VCSIntegrationIssue {
  APP_DELETED = "APP_DELETED",
  PRIVATE_KEY_INVALID = "PRIVATE_KEY_INVALID",
  APP_NOT_INSTALLED = "APP_NOT_INSTALLED",
}

export const VCS_INTEGRATION_ISSUE_MESSAGE: Record<VCSIntegrationIssue, string> = {
  [VCSIntegrationIssue.APP_DELETED]:
    "Your custom App is deleted from GitHub. Please delete and re-create your integration.",
  [VCSIntegrationIssue.PRIVATE_KEY_INVALID]:
    "Spacelift was unable to communicate with your custom App. Please edit this integration and update the private key or contact Spacelift support for more help.",
  [VCSIntegrationIssue.APP_NOT_INSTALLED]:
    "To use your custom App you need to install it first in GitHub.",
};

export const getVCSIntegrationIssue = (
  integration: VcsIntegration
): VCSIntegrationIssue | undefined => {
  if (
    integration.provider !== VcsProvider.GithubEnterprise ||
    integration.details?.__typename !== VCS_INTEGRATION_DETAILS_UNION.GITHUB_ENTERPRISE_INTEGRATION
  ) {
    return undefined;
  }

  if (integration.details.githubAppStatus === GitHubAppStatus.AppNotFound) {
    return VCSIntegrationIssue.APP_DELETED;
  }

  if (integration.details.githubAppStatus === GitHubAppStatus.CouldNotDecode) {
    return VCSIntegrationIssue.PRIVATE_KEY_INVALID;
  }

  if (integration.details.installations.length === 0) {
    return VCSIntegrationIssue.APP_NOT_INSTALLED;
  }

  return undefined;
};
